import { render, staticRenderFns } from "./SendMessageReadMembersModal.vue?vue&type=template&id=6777b013&lang=pug"
import script from "./SendMessageReadMembersModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageReadMembersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports